import { lazy } from "react";

// A missing chunk (a stale service worker, or a deploy that removed the old
// build) reloads the page once. The sessionStorage guard stops a reload loop.
const CHUNK_LOAD_ERROR = /Loading (CSS )?chunk|Failed to fetch dynamically imported module|Importing a module script failed/i;

export function lazyWithRetry(factory, name) {
  const storageKey = "st_chunk_reload:" + name;
  return lazy(() =>
    factory()
      .then((mod) => {
        sessionStorage.removeItem(storageKey);
        return mod;
      })
      .catch((err) => {
        const message = err && typeof err.message === "string" ? err.message : "";
        const chunkFailed =
          (err && err.name === "ChunkLoadError") || CHUNK_LOAD_ERROR.test(message);
        if (!chunkFailed) {
          throw err;
        }
        if (sessionStorage.getItem(storageKey) == null) {
          sessionStorage.setItem(storageKey, "1");
          window.location.reload();
          return new Promise(() => {});
        }
        sessionStorage.removeItem(storageKey);
        throw err;
      }),
  );
}
